import "../styles/ColumnGrid.css";
import {Children} from "react";

const GridRow = ({ children }) => {
    return <>{children}</>;
};

const ColumnGrid = ({ columns, children, gap: rowGap = "10px" }) => {
    return (
        <div style={{ gridTemplateColumns: columns, rowGap }} className="grid">
            {Children.toArray(children).filter(child => child.type === GridRow)}
        </div>
    );
}

export { GridRow, ColumnGrid };